import { useWindowSize } from '@vueuse/core'
import { computed } from 'vue'
import { useI18n } from 'vue-i18n'

import { relativeValues, type TableFilterRelativeValue } from './index.ts'

type FilterLike = { type: 'date' } | { type: 'text' } | { type: 'select'; options: Record<string, string> }

export const useGetFilterValueLabel = () => {
  const { d, t } = useI18n<{ message: Record<TableFilterRelativeValue, string> }, 'en' | 'nl'>({
    useScope: 'global',
    messages: {
      en: {
        today: 'Today',
        yesterday: 'Yesterday',
        tomorrow: 'Tomorrow',
      },
      nl: {
        today: 'Vandaag',
        yesterday: 'Gisteren',
        tomorrow: 'Morgen',
      },
    },
  })

  return (filter: FilterLike, value: string): string => {
    switch (filter.type) {
      case 'select': {
        return filter.options[`${value}`] || value
      }
      case 'date': {
        if (relativeValues.includes(value as TableFilterRelativeValue)) {
          return t(value)
        }
        return d(new Date(value), 'short')
      }
      default: {
        return value
      }
    }
  }
}

export const useTableResponsive = () => {
  const { width } = useWindowSize()
  const isMobile = computed((): boolean => width.value < 1024)

  return {
    isMobile,
  }
}
